var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolumeOffIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "volume-off-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 48,
    height: 48,
    fill: "none",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(10 12)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "_5486a468-cd53-4dd3-9297-a5278d6cf915",
    "data-name": "5486a468-cd53-4dd3-9297-a5278d6cf915",
    d: "M12.571,5.714,6.857,10.286H2.286v6.857H6.857l5.714,4.571Z",
    transform: "translate(-2.286 -1.714)",
    fill: "none",
    stroke: "#0f191b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "_499ade1b-25a9-421f-9f21-d1a49656deb0",
    "data-name": "499ade1b-25a9-421f-9f21-d1a49656deb0",
    x1: 6.857,
    y2: 6.857,
    transform: "translate(17.143 8.572)",
    fill: "none",
    stroke: "#0f191b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "_9a7f2e10-4882-4e2c-abb6-dd556ea46c7f",
    "data-name": "9a7f2e10-4882-4e2c-abb6-dd556ea46c7f",
    x2: 6.857,
    y2: 6.857,
    transform: "translate(17.143 8.572)",
    fill: "none",
    stroke: "#0f191b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOffIcon);
export default __webpack_public_path__ + "static/media/volume-off-icon.30f16ae28bb22480ebb980ecbfecd8b4.svg";
export { ForwardRef as ReactComponent };